import { TemplatePage } from './types';

const mothersDayPage: TemplatePage = {
  header: {
    color: '#F7CD57',
    icon: 'images/video-templates/mothers-day.jpg',
    title: 'Mother’s Day Video Templates',
    title_meta: '500+ Customizable Holiday Video Templates',
    description_meta:
      'Love, that what makes Wave.video Mother’s day video templates stand out, helps to create connections, ' +
      'and makes product placement natural. Fun facts, sales, discounts, promotions, announcements, and so much ' +
      'more for your products, for your mom, and for your clients!',
    description:
      'Made with love, Wave.video’s video templates are not only easily customizable, but they also will make ' +
      'you feel like a pro - in minutes, you will make a beautiful video that touches hearts'
  },
  footer: {
    category: 'Mother’s Day',
    description:
      'Wave.video’s collection of Mother’s Day video templates, offers you plenty of beautiful choices. ' +
      'Customizing them is as easy as one-two-three! Pick any video template you like, add your logo, pick ' +
      'from 300 Google fonts or upload your own.<br>Any visual in the template easily can be placed with your ' +
      'photo and video, color pallet, overlays, any element and any visual can be tweaked to your liking. <br>What ' +
      'are you waiting for? Start creating and make videos you never thought you will be able to make on your own! ' +
      'Enjoy the ride! '
  },
  content: [
    {
      type: 'templates',
      title: 'Mother’s Day Video Templates',
      search: {
        category: "/Holidays & Occasions/Mother's Day"
      }
    },
    {
      type: 'stocks',
      title: 'Mother’s Day',
      search: { name: 'mother' }
    },
    { type: 'calendar' }
  ]
};

export default mothersDayPage;
